exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "course-selector .code {\n  font-size: 12px;\n}\ncourse-selector div.course-preference-actions button {\n  margin-top: 5px;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/gcp-applications/monash-online-credit/monash-online-credit-prod@2/src/main/client/app/shared/course/selector/course-selector.less","/var/lib/jenkins/workspace/gcp-applications/monash-online-credit/monash-online-credit-prod@2/course-selector.less"],"names":[],"mappings":"AAAA;EAGI,gBAAA;CCDH;ADFD;EAQM,gBAAA;CCHL","file":"course-selector.less","sourcesContent":["course-selector {\n\n  .code {\n    font-size: 12px;\n  }\n\n  div.course-preference-actions {\n    button {\n      margin-top: 5px;\n    }\n  }\n}\n","course-selector .code {\n  font-size: 12px;\n}\ncourse-selector div.course-preference-actions button {\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"importLoaders":1}!./node_modules/postcss-loader/lib?{"sourceMap":true,"plugins":[null]}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./src/main/client/app/shared/course/selector/course-selector.less
// module id = 355
// module chunks = 0